exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-item-base[data-v-3eb6b0d9]{background:#fff;border:1px solid #333233;border-radius:10px;padding:24px 20px;margin-bottom:16px}.result-item-title[data-v-3eb6b0d9]{font-weight:600;font-size:18px;line-height:24px;color:#333233;margin:0;margin-bottom:10px}.is-free[data-v-3eb6b0d9]{margin:0}.desc-area-free[data-v-3eb6b0d9]{background:url(\"/static/img/yearluck/y2023/result/blur_text.png\");height:144px;background-size:contain;padding:40px 8px;padding-top:26px}.desc-area-free--full[data-v-3eb6b0d9]{background:url(\"/static/img/yearluck/y2023/result/blur_text_full.png\");height:300px;padding:120px 8px;background-size:contain}.notice[data-v-3eb6b0d9]{text-align:center;font-weight:600;font-size:12px;line-height:18px;color:#303030}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eb6b0d9","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2023/partials/ResultItem.vue
// module id = lKzf
// module chunks = 0